<script setup lang="ts">
import {computed, type HTMLAttributes, onMounted, ref, useSlots} from 'vue'
import {cn} from '@/shared/lib/utils'
import {Check} from 'lucide-vue-next'
import {SelectItem, SelectItemIndicator, type SelectItemProps, SelectItemText, useForwardProps,} from 'radix-vue'

const props =  defineProps<SelectItemProps & {
  label?: string
  selectedLabel?: string
  class?: HTMLAttributes['class']
}>()

const delegatedProps = computed(() => {
  const {class: _, ...delegated} = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
const slots = useSlots();
// State to keep track of whether the default slot is filled
const isDefaultSlotFilled = ref(false);

const selectItemText = ref(props.selectedLabel ?? props.label)

onMounted(() => {
  // Check if the default slot is provided/filled
  isDefaultSlotFilled.value = !!slots.default;
});
</script>

<template>
  <SelectItem
      v-bind="forwardedProps"
      :class="
      cn(
        'relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50',
        props.class,
      )
    "
  >
    <span class="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
      <SelectItemIndicator>
        <Check class="h-4 w-4"/>
      </SelectItemIndicator>
    </span>

    <div class="w-full">
      <SelectItemText v-if="selectItemText" class="hidden">{{ selectItemText }}</SelectItemText>
      <slot v-if="isDefaultSlotFilled"/>
      <span v-else>{{ label }}</span>
    </div>
  </SelectItem>
</template>
